import styled from 'styled-components';

interface RadioInputProps {
  key: string | number;
  value: string;
}

interface RadioItemsProps {
  items: RadioInputProps[];
  register: any;
  onChange?: (event: React.ChangeEvent<HTMLInputElement>) => void;
  registerName?: string;
}

export const RadioInput = ({ items, register, onChange }: RadioItemsProps) => {
  return (
    <RadioBox>
      {items.map((item) => (
        <div key={item.key} className="radio-box">
          <input
            type="radio"
            value={item.key}
            id={item.key}
            {...register('monthValue')}
            onChange={(e) => {
              register('monthValue').onChange(e); // react-hook-form의 onChange 호출
              if (onChange) {
                onChange(e);
              }
            }}
          />
          <label htmlFor={item.key.toString()}>{item.value}</label>
        </div>
      ))}
    </RadioBox>
  );
};

export const RadioButtonInput = ({
  items,
  register,
  onChange,
  registerName = 'radioBtnValue',
}: RadioItemsProps) => {
  return (
    <RadioBtnBox>
      {items.map((item) => (
        <div key={item.key} className="radio-btn-box">
          <input
            type="radio"
            value={item.key}
            id={item.key}
            {...register(registerName)}
            onChange={(e) => {
              register('monthValue').onChange(e); // react-hook-form의 onChange 호출
              if (onChange) {
                onChange(e);
              }
            }}
          />
          <label htmlFor={item.key.toString()}>{item.value}</label>
        </div>
      ))}
    </RadioBtnBox>
  );
};

// style
const RadioBox = styled.div`
  display: flex;
  align-items: center;
  gap: 0.8rem;
  .radio-box {
    flex: 1 0 30%;
    display: flex;
    align-items: center;
    input[type='radio'] {
      display: none;
    }
    label {
      flex: 1 1 auto;
      font-size: 1.3rem;
      font-weight: 400;
      display: flex;
      justify-content: center;
      align-content: center;
      background-color: ${(props) => props.theme.textWhiteColor};
      color: ${(props) => props.theme.btnBlueColor};
      border: 1px solid ${(props) => props.theme.btnBlueColor};
      line-height: 2rem;
      padding: 0.4rem 0;
      border-radius: 0.4rem;
    }
    input[type='radio']:checked + label {
      background-color: ${(props) => props.theme.btnBlueColor};
      color: ${(props) => props.theme.textWhiteColor};
      border: 1px solid ${(props) => props.theme.btnBlueColor};
    }
  }
`;

const RadioBtnBox = styled.div`
  display: flex;
  align-items: center;
  gap: 2.4rem;
  .radio-btn-box {
    display: flex;
    align-items: center;
    input[type='radio'] {
      display: none;
    }
    label {
      padding-left: 3rem;
      display: flex;
      align-items: center;
      font-size: 1.6rem;
      font-weight: 600;
      line-height: 2.2rem;
      position: relative;
      &::after {
        content: '';
        width: 2.2rem;
        height: 2.2rem;
        position: absolute;
        left: 0;
        top: 50%;
        transform: translateY(-50%);
        background: url('/assets/check-ico-gray.svg');
        background-size: cover;
        background-position: center center;
        background-repeat: no-repeat;
      }
    }
    input[type='radio']:checked + label {
      &::after {
        background: url('/assets/check-ico-blue.svg');
        background-size: cover;
        background-position: center center;
        background-repeat: no-repeat;
      }
    }
  }
`;
